import { db, fb } from "../App";
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/app";
import "firebase/compat/functions";
import { goolgePlayPay } from "./googlepay";

/* export const getProducts = async () => {
    if (db && fb) {
        db.collection("Produkte")
            .where("active", "==", true)
            .get()
            .then(function (querySnapshot: any) {
                querySnapshot.forEach(async function (doc: any) {
                    console.log(doc.id, " => ", doc.data());
                    const priceSnap = await doc.ref.collection("prices").get();
                    priceSnap.docs.forEach((doc: any) => {
                        console.log(doc.id, " => ", doc.data());
                    });
                });
            });
    }
}; */

export const startStripeSession = async (priceID: String) => {
  if (db && fb) {
    /*  if ("getDigitalGoodsService" in window) {
            // Digital Goods API is supported!
            goolgePlayPay();
        } else { */
    console.log("DigitalGoodsService is not available.");
    // Use another payment method

    console.log(firebase.auth().currentUser?.uid);
    const docRef = await db
      .collection("Kunden")
      .doc(firebase.auth().currentUser?.uid)
      .collection("checkout_sessions")
      .add({
        price: priceID,
        success_url: window.location.origin,
        cancel_url: window.location.origin,
        payment_method_types: ["card", "sepa_debit"],
      });
    // Wait for the CheckoutSession to get attached by the extension
    docRef.onSnapshot((snap) => {
      const { error, url }: any = snap.data();
      if (error) {
        // Show an error to your customer and
        // inspect your Cloud Function logs in the Firebase console.
        alert(`An error occured: ${error.message}`);
      }
      if (url) {
        // We have a Stripe Checkout URL, let's redirect.
        window.location.assign(url);
      }
    });
  }
  /*    } */
};

export const getSubscription = async () => {
  if (db && fb) {
    console.log(firebase.auth().currentUser?.uid);
    const querySnapshot = await db
      .collection("Kunden")
      .doc(firebase.auth().currentUser?.uid)
      .collection("subscriptions")
      .get();
    var subs: firebase.firestore.DocumentData[] = [];
    querySnapshot.forEach((doc) => subs.push(doc));
    return subs;
  }
  return [];
};

export const redirectToCustomerPortal = async () => {
  if (db && fb) {
    const functionRef = fb
      .functions("europe-west3")
      .httpsCallable("ext-firestore-stripe-subscriptions-createPortalLink");
    const { data } = await functionRef({
      returnUrl: window.location.origin,
    });
    window.location.assign(data.url);
  }
};
